import { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import styled from 'astroturf/react'

import PhoneField from 'components/form/phone'
import TextField from 'components/form/text'
import {
  singleLocationConfigurationSelector,
  locationPhoneNumberSelector,
  selectedLocationSelector,
  inviteeLocationErrorsSelector,
  inviteePhoneNumberErrorsSelector,
  countryCodeSelector, locationLabelSelector
} from 'selectors'
import {
  selectLocationConfiguration,
  onLocationChange,
  onPhoneNumberChange
} from 'actions/scheduling'
import { dismissValidationError } from 'actions/errors'
import { useI18n } from 'locales'
import _Spacing from "index-Spacing.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/single/index.js?styleId=Spacing";


const Spacing = /*#__PURE__*/styled('div', null, {
  displayName: "Spacing",
  styles: _Spacing
})

const SingleLocation = ({
  locationConfiguration,
  location,
  phoneNumber,
  countryCode,
  onLocationSelected,
  handleLocationChange,
  handlePhoneNumberChange,
  locationErrors,
  phoneNumberErrors
}) => {
  const { i18n } = useI18n()
  const labelText = useSelector(locationLabelSelector)

  useEffect(() => {
    onLocationSelected(locationConfiguration)
  }, [locationConfiguration, onLocationSelected])

  if (locationConfiguration.kind === 'ask_invitee') {
    return (
      <Spacing>
        <TextField
          label={labelText}
          name="location"
          onChange={handleLocationChange}
          value={location}
          error={locationErrors?.[0]}
          placeholder={i18n.t('booking.location.ask_invitee.placeholder')}
          required
        />
      </Spacing>
    )
  }

  if (locationConfiguration.kind === 'outbound_call') {
    return (
      <Spacing>
        <PhoneField
          label={labelText}
          name="phone_number"
          number={phoneNumber}
          error={phoneNumberErrors?.[0]}
          onChange={handlePhoneNumberChange}
          countryCode={countryCode}
          required
        />
      </Spacing>
    )
  }

  return null
}

const mapStateToProps = (state) => ({
  location: selectedLocationSelector(state),
  phoneNumber: locationPhoneNumberSelector(state),
  locationConfiguration: singleLocationConfigurationSelector(state),
  locationErrors: inviteeLocationErrorsSelector(state),
  phoneNumberErrors: inviteePhoneNumberErrorsSelector(state),
  countryCode: countryCodeSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
  onLocationSelected: (locationConfiguration) => {
    dispatch(selectLocationConfiguration(locationConfiguration))
  },
  handleLocationChange: (event) => {
    dispatch(onLocationChange(event.target.value))
    dispatch(dismissValidationError('event', 'location'))
  },
  handlePhoneNumberChange: (event) => {
    dispatch(onPhoneNumberChange(event))
    dispatch(dismissValidationError('event', 'phone_number'))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleLocation)
